// Adding a domain both excludes it from analytics and grants the ?today= pin.
const CHAPTR_EMAIL_DOMAINS = ["@chaptr.com", "@chapt.xyz", "@chaptr.ai"];

export const isChaptrEmail = (email: string | null | undefined) => {
  const normalised = email?.trim().toLowerCase() ?? "";
  return CHAPTR_EMAIL_DOMAINS.some((domain) => normalised.endsWith(domain));
};
